var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('router-view',{staticClass:"router mt-5"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-basic has-text-centered"},[_c('p',[_c('strong',[_vm._v("Shreddify")]),_vm._v(" by "),_c('a',{attrs:{"href":"https://github.com/disco-trooper"}},[_vm._v("disco_trooper")]),_vm._v(". ")])])
}]

export { render, staticRenderFns }